var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#827c78",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.647 8.36a1.137 1.137 0 0 0-1.44-.134c-1.694 1.15-10.196 6.932-11.11 7.842a3.375 3.375 0 0 0 0 4.783c.662.66 1.533.99 2.403.99.87 0 1.74-.33 2.403-.99.914-.91 6.723-9.37 7.879-11.058.306-.448.25-1.05-.135-1.432zM16.3 19.258c-.442.44-1.16.44-1.602 0a1.125 1.125 0 0 1 0-1.594c.355-.35 2.769-2.063 5.739-4.118-2.065 2.956-3.786 5.358-4.137 5.712z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.224 23.704l-1.398.678a12.067 12.067 0 0 1-.764-10.246l1.602.766a1.133 1.133 0 0 0 1.512-.53 1.125 1.125 0 0 0-.532-1.503l-1.582-.756a12.257 12.257 0 0 1 9.305-5.778V8.03A1.13 1.13 0 0 0 15.5 9.158a1.13 1.13 0 0 0 1.133-1.127V6.334a12.14 12.14 0 0 1 3.895 1.021c.57.256 1.241.004 1.499-.563A1.125 1.125 0 0 0 21.46 5.3a14.448 14.448 0 0 0-5.96-1.272A14.44 14.44 0 0 0 5.247 8.255 14.303 14.303 0 0 0 1 18.46c0 2.848.85 5.618 2.457 8.01a1.134 1.134 0 0 0 1.438.388l2.322-1.128c.563-.273.796-.948.522-1.507a1.135 1.135 0 0 0-1.515-.52zM28.722 12.528a1.135 1.135 0 0 0-1.499-.564c-.57.256-.823.924-.566 1.491a12.032 12.032 0 0 1 1.077 5.005c0 2.08-.538 4.111-1.564 5.93l-1.46-.691a1.135 1.135 0 0 0-1.51.533 1.125 1.125 0 0 0 .536 1.503l2.379 1.127a1.134 1.134 0 0 0 1.428-.391A14.326 14.326 0 0 0 30 18.46c0-2.067-.43-4.063-1.278-5.932z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.abd2df750ee2a127e4b25c927ee50113.svg";
export { ForwardRef as ReactComponent };